<template>
  <div>
    <v-dialog scrollable persistent width="428px" v-model="openWebinar.flag">
      <v-form ref="validateWebinar">
        <v-card>
          <v-card-title class="title justify-space-between">
            <div>Add Webinar</div>
            <div>
              <v-btn @click="closeWebinar()" icon>
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>
          <v-card-text>
            <section class="mb-5" style="position: relative">
              <v-img
                v-if="webinar_cover_file"
                class="webinar-img mt-4 mb-2"
                :src="webinar_cover_preview"
              >
              </v-img>
              <v-img v-else class="webinar-img mt-4 mb-2" :src="webinarCover">
              </v-img>
              <label for="webinar_cover" class="webinar-cover-label">
                <span class="change_cover">
                  <span>
                    <input
                      @change="uploadCover()"
                      ref="group_cover_field"
                      id="webinar_cover"
                      accept="image/*"
                      type="file"
                      style="visibility: hidden; width: 10px"
                    />
                    <v-icon small>mdi-camera-outline</v-icon>

                    <span class="ml-2">Add Picture</span>
                  </span>
                </span>
              </label>
            </section>
            <section class="mt-7 px-3">
              <v-row>
                <!-- title -->
                <v-col cols="12" class="mb-5 mt-10">
                  <label style="color: #333333bd">
                    Title
                    <span style="color: red">*</span>
                    <v-text-field
                      dense
                      outlined
                      placeholder="Enter title..."
                      v-model="title"
                      hide-details="auto"
                      :rules="[rules.required]"
                      maxlength="50"
                    />
                  </label>
                </v-col>
                <!-- Description -->
                <v-col cols="12" class="mb-5">
                  <label style="color: #333333bd">
                    Description
                    <span style="color: red">*</span>
                    <vue-editor
                      :editorToolbar="customToolbar"
                      :rules="[rules.required]"
                      v-model="description"
                      placeholder="Enter description..."
                      style="border-radius: 12px"
                    ></vue-editor>

                    <!--<v-textarea
                      :rules="[rules.required]"
                      dense
                      outlined
                      placeholder="Enter description..."
                      v-model="description"
                      hide-details="auto"
                      rows="5"
                    /> -->
                  </label>
                </v-col>
                <!-- Date -->
                <v-col class="pr-2" cols="6">
                  <label style="color: #333333bd">
                    Date
                    <span style="color: red">*</span>

                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                    >
                      <!-- min-width="290px" -->
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateFormattedText"
                          :rules="[rules.required]"
                          placeholder="Select Date"
                          outlined
                          class="text-box"
                          background-color="#fff"
                          multiple
                          dense
                          ref="inputField"
                          readonly
                          append-icon="mdi-calendar-range"
                          v-bind="attrs"
                          v-on="on"
                          clearable
                          @click:clear="dates = []"
                          @click:append="
                            (menu = !menu), $refs.inputField.focus()
                          "
                        ></v-text-field>
                        <!-- {{dateFormattedText}} -->
                      </template>
                      <v-date-picker v-model="dates" range no-title scrollable>
                        <!-- @input="getGroupDetails" -->
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"
                          >Cancel</v-btn
                        >
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.menu.save(dates)"
                          >OK</v-btn
                        >
                      </v-date-picker>
                    </v-menu>
                  </label>
                </v-col>
                <!-- Time -->
                <v-col class="pl-2" cols="6">
                  <label style="color: #333333bd">
                    Time
                    <span style="color: red">*</span>

                    <v-menu
                      ref="timemenu"
                      v-model="timemenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          :rules="[rules.required]"
                          v-model="time"
                          placeholder="Select Time"
                          dense
                          append-icon="mdi-clock"
                          v-bind="attrs"
                          outlined
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="timemenu"
                        dense
                        v-model="time"
                        format="ampm"
                        no-title
                        @change="save"
                      ></v-time-picker>
                    </v-menu>
                  </label>
                </v-col>
                <!-- Duration -->
                <v-col cols="12" class="">
                  <label style="color: #333333bd">
                    Duration
                    <span style="color: red">*</span>
                    <v-text-field
                      :rules="[rules.required, rules.number]"
                      dense
                      outlined
                      placeholder="Enter Duration"
                      v-model="duration"
                      hide-spin-buttons
                      type="number"
                      maxlength="50"
                    >
                      <template v-slot:append>
                        <span class="mt-1 mr-1"
                          ><v-divider vertical></v-divider>
                        </span>
                        <span style="margin-right: 5px; margin-top: 5px">
                          Hours</span
                        >
                      </template>
                    </v-text-field>
                  </label>
                </v-col>
                <!-- Level -->
                <v-col class="" cols="12">
                  <label style="color: #333333bd">
                    Level
                    <span style="color: red">*</span>

                    <v-select
                      placeholder="Select"
                      :rules="[rules.required]"
                      outlined
                      dense
                      v-model="level"
                      :items="level_items"
                    >
                    </v-select>
                  </label>
                </v-col>
                <!-- price -->
                <v-col cols="12" class="">
                  <label style="color: #333333bd">
                    Price
                    <!-- <span style="color: red">*</span> -->
                    <v-text-field
                      :rules="price ? [rules.number] : []"
                      dense
                      outlined
                      placeholder="Enter Price"
                      v-model="price"
                      type="number"
                      hide-spin-buttons
                    >
                    </v-text-field>
                  </label>
                </v-col>
              </v-row>
            </section>
          </v-card-text>
          <v-card-actions>
            <v-btn
              @click="getWebinarList()"
              :loading="loading"
              width="100%"
              height="46px"
              class="add-btn"
              color="primary"
              block
              >Add
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import newAxios from "@/api/newAxios";
import RULES from "@/common/fieldRules";
import { VueEditor } from "vue2-editor";

export default {
  name: "AddWebinar",
  props: {
    openWebinar: {
      type: Object,
      required: true,
    },
  },
  // YYYY-MM-DD
  // HH:MM
  components: {
    VueEditor,
  },
  data() {
    return {
      rules: RULES,

      loading: false,
      // date
      menu: false,
      date: null,
      dates: [],
      // time
      timemenu: false,
      time: null,

      webinarCover: require("@/assets/images/group_cover_image.svg"),
      webinar_cover_file: "",
      webinar_cover_preview: "",
      // varaible
      title: "",
      description: "",
      duration: null,
      level: "",
      level_items: ["Beginner", "Intermediate", "Advanced"],
      price: null,
      customToolbar: [
        // Specify the desired toolbar options
        [{ header: [1, 2, false] }], // Only h1, h2, and normal text
        ["bold", "italic"], // Bold and italic
        [{ list: "ordered" }, { list: "bullet" }], // Ordered and bullet lists
        // ["link"],  Hyperlink
        ["clean"], // Clear formatting
      ],
    };
  },
  computed: {
    dateFormattedText: {
      get() {
        if (this.dates.length) {
          if (this.dates.length == 1) {
            return this.moment(this.dates[0]).format("YYYY-MM-DD");
          } else {
            return `${this.moment(this.dates[0]).format(
              "YYYY-MM-DD"
            )},${this.moment(this.dates[1]).format("YYYY-MM-DD")}`;
          }
        } else {
          return "";
        }
      },
    },
  },
  methods: {
    uploadCover() {
      this.webinar_cover_file = this.$refs.group_cover_field?.files?.item(0);
      this.webinar_cover_preview = URL.createObjectURL(this.webinar_cover_file);
    },
    save(time) {
      this.$refs.timemenu.save(time);
    },
    closeWebinar() {
      this.openWebinar.flag = false;
      this.title = "";
      this.description = "";
      this.price = null;
      this.webinar_cover_file = "";
      this.webinar_cover_preview = "";
      this.duration = null;
      this.level = "";
      this.date = null;
      this.dates = [];
    },

    getWebinarList() {
      if (this.$refs.validateWebinar.validate()) {
        this.loading = true;
        const onSuccess = () => {
          // console.log(res);
          this.eventBus.$emit("reload-webinar");
          this.openWebinar.flag = false;
          this.loading = false;
          this.closeWebinar();
        };
        const onFailure = (err) => {
          console.log(err);
          this.loading = false;
        };
        let data = new FormData();
        if (this.webinar_cover_file) {
          data.append("picture", this.webinar_cover_file);
        }
        data.append("title", this.title);
        data.append("description", this.description);
        data.append("date", this.dates);
        data.append("time", this.time);
        data.append("duration", this.duration);
        data.append("duration", this.duration);
        data.append("level", this.level);
        if (this.price) {
          data.append("price", this.price);
        }

        newAxios("post", "trending/create-webinar/", {
          data,
          onSuccess,
          onFailure,
          isTokenRequired: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.webinar-cover-label {
  cursor: pointer;
  // position: absolute;
  // right: 0;
  // left: 32%;
  // bottom: -10px;
}

#webinar_cover {
  position: absolute;
}

.change_cover {
  position: absolute;
  left: 34%;
  top: 187px;
  // z-index: 9;
  margin-left: 0;
  margin-right: 0;
  // position: absolute;
  // right: 0;
  // left: 0;
  //
  padding: 12px;
  background: #ffffff;
  border: 2px solid #e4e4e4;
  border-radius: 80px;
  //styleName: Para/Normal/Regular;
  font-family: Avenir;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  color: #283037;
}

.add-btn {
  border-radius: 6px;
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 21.86px;
  text-align: center;
  text-transform: capitalize;
}

.webinar-img {
  width: 384px;
  height: 214px;
  border-radius: 12px;
}

.title {
  color: #fff;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1.625rem;
  /* 130% */
  background: var(--Primary-Blue, #2d8cff);
}
</style>
